<template>
  <a-layout class='index animated fadeIn s_bf'>
    <SmallSquare content='若开启微信卡包，每次修改会员特权等内容后，需要关闭再重启微信卡包才能生效。' :padding='true' ></SmallSquare>
    <a-card :bordered="false">
      <cardPackage />
    </a-card>
  </a-layout>
</template>
<script>
  import cardPackage from './components/cardPackage'
  export default {
    components: {  cardPackage },
  }
</script>